import type { FC } from "react";
import { Alert, AlertTitle, Stack } from "@mui/material";

interface TestSectionProps {
  text?: string;
}

const TestSection: FC<TestSectionProps> = ({ text }) => {
  return (
    <Stack sx={{ width: "100%" }} spacing={2}>
      <Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        {text ? (
          text
        ) : (
          <p>
            You are running the application in — <strong>TEST MODE!</strong>
          </p>
        )}
      </Alert>
    </Stack>
  );
};
export default TestSection;
